import { createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../../data/axiosInstance/axiosInstance';
import executor from '../../../data/axiosInstance/executor';
import { openAlert, startLoading, stopLoading } from '../DataQualityStatus/DataQualitySlice';
import { getUserInfo } from "../../../msalInstance";

const API_URL = `${process.env.REACT_APP_API_SINISTRI_URL}`;
const USE_API = true;


const initialState = {
  refreshCount: 0,
  callWithUser: false,
  statusCount: [],
  activeFilter: {},

  productTypeList: [],
  versionList: [],
  activitiesStatusCount: [],
  activitiesCount: 0,

  productTypes: [],
  filterProductTypes: [],

  rollCallStatusDomains: [],
  filterStatusCountDomains: []

};


export const DataRollCallSliceSlice = createSlice({
  name: 'dataRollCall',
  initialState,
  reducers: {
    //General
    setRefreshCount: (state, action) => {
      state.refreshCount = action.payload
    },
    // toogleLoading: (state) => {
    //   state.loading = !state.loading;
    // },
    // startLoading: (state) => {
    //   state.loading = true
    // },
    // stopLoading: (state) => {
    //   state.loading = false
    // },
    setCallWithUser: (state, action) =>{
      state.callWithUser = action.payload
    },
    //Values
    getStatusCount: (state, action) => {
      state.statusCount = action.payload;
    },
    getProductTypeList: (state, action) => {
      state.productTypeList = action.payload
    },
    getRollCallStatusDomains: (state, action) => {
      state.rollCallStatusDomains = action.payload
    },
    getVersionList: (state, action) => {
      state.versionList = action.payload;
    },
    getProductTypes: (state, action) => {
      state.productTypes = action.payload
    },
    getActivitiesStatusCount: (state, action) => {
      state.activitiesStatusCount = action.payload
    },
    getActivitiesCount: (state, action) => {
      state.activitiesCount = action.payload
    },

    //Filters
    setActiveFilter: (state, action) => {
      state.activeFilter = action.payload;
    },
    setFilterProductTypes: (state, action) => {
      state.filterProductTypes = action.payload
    },
    setFilterStatusCount: (state, action) => {
      state.filterStatusCountDomains = action.payload
    },
  }
});


export const {
  //General
  setRefreshCount,
  // toogleLoading,
  // startLoading,
  // stopLoading,
  setCallWithUser,

  //Values
  getStatusCount,
  getProductTypeList,
  getRollCallStatusDomains,
  getProductTypes,
  getVersionList,
  getActivitiesStatusCount,
  getActivitiesCount,



  //Filters
  setActiveFilter,
  setFilterProductTypes,
  setFilterStatusCount,

} = DataRollCallSliceSlice.actions;


export const fetchStatusCount = (domains, dataProducts) => async (dispatch) => {
  console.debug('fetchStatusCount ', domains);
  dispatch(startLoading());
  dispatch(getStatusCount([]));
  let res
  let err
  
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataRoll/statusCount`;
    const fetchData = async () => axiosInstance.post(API_URI_CALL, {domainList: domains || undefined, productList: dataProducts || []});
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(openAlert({ message: "Error during the retrieval of status count: " + err?.response?.headers?.apierror, type: "danger" }));
    }
  } else {
    res = {
      "data":
        [
          {
            "roll_call_status_id": "1",
            "roll_call_status_name": "Waiting",
            "count": 4,
            "info": {
              "color": "#ffff00"
            }
          },
          {
            "roll_call_status_id": "2",
            "roll_call_status_name": "Row 2",
            "count": 14,
            "info": {
              "color": "red"
            }
          },
          {
            "roll_call_status_id": "3",
            "roll_call_status_name": "Row 3",
            "count": 214,
            "info": {
              "color": "black"
            }
          }
        ]
    };
  }

  console.debug('fetchStatusCount res', res);
  dispatch(getStatusCount(res?.data || []));
  return dispatch(stopLoading());
};
export const fetchProductTypeList = (rollCallStatusDomains, domains, callWithUser, dataProducts) => async (dispatch) => {
  console.debug('fetchProductTypeList...')
  dispatch(startLoading());
  dispatch(getProductTypeList([]));
  let res
  let err

  let decoded = {};
  decoded = getUserInfo();

  
  if (USE_API) {
    const API_URI_CALL = (callWithUser) ?  `${API_URL}/api/v1/portal/dataRoll/productTypeList?userName=` + decoded.email : `${API_URL}/api/v1/portal/dataRoll/productTypeList`;
    const fetchData = async () => axiosInstance.post(API_URI_CALL, {
      statusList: rollCallStatusDomains || [],
      domainList: domains || [],
      productList: dataProducts || []
    });
    [res, err] = await executor.executeAsync(fetchData)
    if (err) {
      dispatch(openAlert({ message: "Error during the retrieval of the product list: " + err?.response?.headers?.apierror, type: "danger" }));
    }

  } else {
    //to Load local json without API
  }

  console.debug('fetchProductTypeList res', res);
  dispatch(getProductTypeList(res?.data || []));
  return dispatch(stopLoading());

};
export const fetchRollCallStatusDomains = (isValid) => async (dispatch) => {
  console.debug('DataRollCall::fetchRollCallStatusDomains', isValid);
  dispatch(startLoading());
  dispatch(getRollCallStatusDomains([]));
  let res = null
  let err = null
  if (USE_API) {

    const API_URI_CALL = `${API_URL}/api/v1/portal/dataRoll/getRollCallStatusDomains/` + isValid?.toString();
    const fetchData = async () => axiosInstance.get(API_URI_CALL, {});
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(openAlert({ message: "Error during the retrieval of status domains: " + err?.response?.headers?.apierror, type: "danger" }));
    }
    res?.data?.unshift({ rollCallStatusDesc: "All", rollCallStatusName: "All", rollCallStatusId: null })
  } else {
    res = {}
  }
  dispatch(getRollCallStatusDomains(res?.data || []));
  return dispatch(stopLoading());

};
export const fetchVersionList = (rollCallStatusDomains, domains, productTypes, callWithUser, dataProducts) => async (dispatch) => {
  console.debug('fetchVersionList...')
  dispatch(startLoading());
  dispatch(getVersionList([]));
  let res
  let err
  

  let decoded = {};
  decoded = getUserInfo();

  if (USE_API) {
    const API_URI_CALL = (callWithUser) ? `${API_URL}/api/v1/portal/dataRoll/versionList?userName=`+ decoded.email :`${API_URL}/api/v1/portal/dataRoll/versionList`;
    const fetchData = async () => axiosInstance.post(API_URI_CALL, {
      statusList: rollCallStatusDomains || [],
      domainList: domains || [],
      products: productTypes || [],
      productsList: dataProducts || []
    });
    [res, err] = await executor.executeAsync(fetchData)
    if (err) {
      dispatch(openAlert({ message: "Error during the retrieval of the version list: " + err?.response?.headers?.apierror, type: "danger" }));
    }

  } else {
    //to Load local json without API
  }

  console.debug('fetchVersionList res', res);
  dispatch(getVersionList(res?.data || []));
  return dispatch(stopLoading());

};
export const fetchProductTypes = () => async (dispatch) => {
  console.debug('DataRollCall::fetchProductTypes');
  dispatch(startLoading());
  dispatch(getProductTypes([]));
  let res = null
  let err = null
  
  if (USE_API) {
    const API_URI_CALL = `${API_URL}/api/v1/portal/dataRoll/productTypes`;
    const fetchData = async () => axiosInstance.get(API_URI_CALL);
    [res,err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(openAlert({ message: "Error during the retrieval of product types: " + err?.response?.headers?.apierror, type: "danger" }));
    }
    res?.data?.unshift({productName: "All", productId: null })
  } else {
    res = {}
  }
  dispatch(getProductTypes(res?.data || []));
  return dispatch(stopLoading());

};
export const fetchActivitiesStatusCount = () => async (dispatch) => {
  console.debug('DataRollCall::fetchActivitiesStatusCount');

  dispatch(startLoading());
  dispatch(getActivitiesStatusCount([]));
  let decoded = {};
  decoded = getUserInfo();

  let res = null
  let err = null
  
  if (USE_API) {

    const API_URI_CALL = `${API_URL}/api/v1/portal/dataRoll/activitiesStatusCount?userName=`+ decoded.email;
    const fetchData = async () => axiosInstance.post(API_URI_CALL);
    [res,err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(openAlert({ message: "Error during the retrieval of activities: " + err?.response?.headers?.apierror, type: "danger" }));
    }
  } else {
    res = {}
  }
  dispatch(getActivitiesStatusCount(res?.data || []));
  return dispatch(stopLoading());

};
export const fetchActivitiesCount = () => async (dispatch) => {
  console.debug('DataRollCall::fetchActivitiesCount');
  dispatch(startLoading());
  dispatch(getActivitiesCount([]));
  let decoded = {};
  decoded = getUserInfo();

  let res = null
  let err = null

  if (USE_API) {

    const API_URI_CALL = `${API_URL}/api/v1/portal/dataRoll/activitiesCount?userName=`+ decoded.email;
    const fetchData = async () => axiosInstance.post(API_URI_CALL);
    [res, err] = await executor.executeAsync(fetchData);
    if (err) {
      dispatch(openAlert({ message: "Error during the retrieval of activities count: " + err?.response?.headers?.apierror, type: "danger" }));
    }
  } else {
    res = {}
  }
  dispatch(getActivitiesCount(res?.data || 0));
  return dispatch(stopLoading());

};


export default DataRollCallSliceSlice.reducer;
